// extracted by mini-css-extract-plugin
module.exports = {"green":"styles-module--green--Vc0Kl","zebra":"styles-module--zebra--3z20-"};